import React from 'react';
import { StaticImage, GatsbyImage } from 'gatsby-plugin-image';

import { ButtonLink } from '../common';
import './BannerAdDynamic.scss';

// TEALIUM
import initTealiumTracker from 'tealium-tracker';
let tealiumTrackEvent;
if (typeof window !== 'undefined') {
  const { trackEvent } = initTealiumTracker({ debugMode: true });
  tealiumTrackEvent = trackEvent;
}

type TCTA_Button = {
  __typename: string;
  buttonText: string;
  buttonURL: string;
};

type TAppstore_Buttons = {
  __typename: string;
  appleAppStoreUrl: string;
  googlePlayStoreUrl: string;
};
export interface IBannerAdDynamicProps {
  ad: {
    Title: string;
    Description: string;
    Image: any;
    CTA_Type: TCTA_Button[] | TAppstore_Buttons[];
  };
  size: 'large' | 'small';
}

const BannerAdDynamic = ({
  ad: { Title, Description, Image, CTA_Type },
  size = 'large',
}: IBannerAdDynamicProps) => {
  const [cta] = CTA_Type;

  const renderCta = (cta: TCTA_Button | TAppstore_Buttons) => {
    const { buttonText, buttonURL } = cta as TCTA_Button;
    const { appleAppStoreUrl, googlePlayStoreUrl } = cta as TAppstore_Buttons;
    if (cta.__typename === 'allStrapi_ComponentAdsCtaButton') {
      return (
        <ButtonLink
          path={buttonURL}
          type="secondary"
          tealiumConfig={{
            dataLinkType: 'banner__primary-button',
            dataLinkName: `Banner Primary - ${buttonText}`,
          }}
        >
          {buttonText}
        </ButtonLink>
      );
    }

    if (cta.__typename === 'allStrapi_ComponentAdsAppstoreButtons') {
      return (
        <div className="appstore-buttons">
          <a
            href={appleAppStoreUrl}
            className="button"
            title="Download on the Apple App Store"
            aria-label="Download on the Apple App Store"
            onClick={() => {
              tealiumTrackEvent({
                linktype: 'banner__apple-store-button',
                linkname: 'Banner Apple App Store',
              });
            }}
            data-linktype="banner__apple-store-button"
            data-linkname="Banner Apple App Store"
          >
            <StaticImage
              src="../../../static/images/ads/badge-apple-app-store.png"
              alt=""
              width={150}
              height={50}
              placeholder="blurred"
            />
          </a>
          <a
            href={googlePlayStoreUrl}
            className="button"
            title="Download on the Google Play Store"
            aria-label="Download on the Google Play Store"
            onClick={() => {
              tealiumTrackEvent({
                linktype: 'banner__google-play-store-button',
                linkname: 'Google Play Store Button',
              });
            }}
            data-linktype="banner__google-play-store-button"
            data-linkname="Google Play Store Button"
          >
            <StaticImage
              src="../../../static/images/ads/badge-google-play.png"
              alt=""
              width={142}
              height={42}
              placeholder="blurred"
            />
          </a>
        </div>
      );
    }

    return null;
  };

  return (
    <section className={`banner-ad-dynamic banner-ad-dynamic--${size}`}>
      <div className="banner-ad-dynamic__inner">
        <div className="banner-ad-dynamic__content">
          <h2 className="title">{Title}</h2>
          <p className="description">{Description}</p>
          {renderCta(cta)}
        </div>
        <div className="banner-ad-dynamic__image-container">
          <GatsbyImage
            className=" banner-ad-dynamic__image"
            image={Image.imageFile.childImageSharp.gatsbyImageData}
            alt=""
          />
        </div>
      </div>
    </section>
  );
};

export default BannerAdDynamic;
